<app-metrics-dimensions-picker [type]="paramDef.options.type"
                               [control]="control"
                               [controlName]="paramDef.controlName"
                               [max]="paramDef.options.max"
                               [form]="form"
                               [options]="options$ | async"
                               [categories]="categories$ | async"
                               [sources]="sources$ | async"></app-metrics-dimensions-picker>
